export default "__VITE_ASSET__Dr5ae44z__"